var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShippingTruck = function SvgShippingTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 2.333C0 1.598.598 1 1.333 1h6c.736 0 1.334.598 1.334 1.333V3h1.056c.354 0 .694.14.944.39l.943.943c.25.25.39.59.39.944v3.056c0 .736-.598 1.334-1.333 1.334h-.07a1.834 1.834 0 0 1-3.528 0H4.93a1.834 1.834 0 0 1-3.529 0h-.069A1.335 1.335 0 0 1 0 8.333zm10.667 4V5.277l-.944-.944H8.667v2zM4 9.167a.833.833 0 1 0-1.667 0 .833.833 0 0 0 1.667 0M8.833 10a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667"
  })));
};
export default SvgShippingTruck;